import React from 'react';
import ReactBigCalendar from 'react-big-calendar';
import moment_timezone from 'moment-timezone';
moment_timezone.tz.setDefault('America/New_York');

ReactBigCalendar.setLocalizer(
  ReactBigCalendar.momentLocalizer(moment_timezone)
);

const BigCalendar = props => {
  return <ReactBigCalendar {...props} />;
};

export default BigCalendar;

export const formatTimeGutter = (date, culture, localizer) => {
  return localizer.format(date, 'h a', culture);
};

export const formatDate = (date, culture, localizer) => {
  const format = localizer.format(date, 'm') === '0' ? 'ha' : 'h[:]mma';
  return localizer.format(date, format, culture);
};

export const formatDayOfWeek = (date, culture, localizer) => {
  return localizer.format(date, 'ddd', culture);
};

export const formatDateRange = ({ start, end }, culture, localizer) => {
  const startFormat = localizer.format(start, 'm') === '0' ? 'ha' : 'h[:]mma';
  const endFormat = localizer.format(end, 'm') === '0' ? 'ha' : 'h[:]mma';
  return `${localizer.format(start, startFormat, culture)} - ${localizer.format(
    end,
    endFormat,
    culture
  )}`;
};



// WEBPACK FOOTER //
// ./src/components/shared/BigCalendar.js